import PartofSpeech from "./RPoS";

export default function Definitions(props) {
  //console.log(props.definitions);
  let word = props.definitions.word;
  return (
    <section>
      {props.definitions.meanings.map(function (meanings, index) {
        return (
          <section className="Meanings" key={index}>
            <PartofSpeech meanings={meanings} word={word} />
          </section>
        );
      })}
    </section>
  );
}
